<template>
  <vx-card :title="memberData.member_username || '-'" no-shadow>
    <!-- Loading overlay -->
    <div v-if="isLoading" class="loading-overlay">
      <vs-loading color="primary" type="point" />
      <p class="mt-2">กำลังโหลดข้อมูล...</p>
    </div>

    <vs-list v-if="!isLoading">
      <!-- Credit Section -->
      <vs-list-header title="Credit" icon="monetization_on"></vs-list-header>
      <div class="credit-info">
        <p class="text-danger">ยอดเงิน : <span class="text-success">{{currency(memberData.member_balance)}} บาท</span></p>
        <p class="text-danger">ยอดเงินในเกม : <span class="text-success">{{currency(memberData.igBalance)}} บาท</span></p>
        <p class="text-danger">ยอดลิมิตถอน : {{ currency(memberData.member_limitwithdraw) }} บาท</p>
        <p :class="memberData.member_level == 3 ? 'text-danger' : 'text-success'">
          สถานะลิมิตถอน : {{ memberData.member_level == 3 ? 'ติดสถานะลิมิตถอน' : 'ไม่ติดสถานะอั้นถอน' }}
        </p>
      </div>

      <!-- KYC Status -->
      <div class="kyc-status">
        <p :class="memberData.member_kyc ? 'text-success' : 'text-danger'">
          สถานะ KYC : <span :class="memberData.member_kyc ? 'text-success' : 'text-danger'">
            {{ memberData.member_kyc ? 'ยืนยันแล้ว' : 'ยังไม่ยืนยัน' }}
          </span>
        </p>
      </div>

      <!-- Bonus Information -->
      <div class="bonus-info">
        <p :class="memberData.member_bonus == 0 ? 'text-success' : 'text-danger'">
          โบนัสล่าสุดที่ลูกค้ารับ : {{statusBonus[0][memberData.member_bonus]}}
        </p>
        <p :class="getBonusTypeClass(memberData.member_bonus_type)">
          ประเภทโบนัสล่าสุดที่ลูกค้ารับ : <span class="text-success">{{getBonusTypeText(memberData.member_bonus_type)}}</span>
        </p>
      </div>

      <!-- Comments -->
      <p>หมายเหตุ : {{ commentData.length > 0 ? commentData[0].comment : 'ไม่มี' }}</p>
      <vs-divider />
      <div
        v-for="(row, idx) in paymentRulePreviewRows"
        :key="`pr-${idx}-${row.amount}`"
        class="mb-3"
      >
        <p class="text-primary mb-1">
          ถ้าฝาก {{ currency(parseFloat(row.amount).toFixed(2)) }} บาท
        </p>
        <p v-if="row.error" class="text-danger">
          {{ row.error }}
        </p>
        <template v-else>
          <p class="text-success">
            {{ row.ruleName || '—' }}
          </p>
          <p class="text-warning">
            {{ row.paymentCode || '—' }}
          </p>
        </template>
      </div>
      <vs-divider />

      <!-- Member Level Information -->
      <div class="member-level">
        <p>ระดับการเป็นสมาชิกลูกค้า : {{ memberData.member_rank }}</p>
        <p>ระดับ Ranking : VIP {{memberData.ranking_level}}</p>
        <p>ยอดเทิร์นโอเวอร์ Ranking : {{currency(memberData.member_sum_turnranking)}}</p>
      </div>
      <vs-divider />

      <!-- Turnover Information -->
      <div class="turnover-info">
        <p>ยอดเทิร์นโอเวอร์ที่ลูกค้าทำปัจจุบัน : {{currency(memberData.member_sum_turnover)}}</p>
        <p>ยอดเทิร์นโอเวอร์ขั้นต่ำที่ต้องทำ : {{currency(memberData.member_turnover)}}</p>
        <p>ยอดคืนยอดเล่น : {{currency(memberData.member_turn_point)}}</p>
        <p>ยอดแนะนำเพื่อน : {{currency(memberData.member_aff_point)}}</p>
      </div>

      <!-- Old Username Section -->
      <!-- <vs-divider />
      <div class="old-username-section">
        <h3>ดึงข้อมูลยูสเก่าจาก UFA</h3>
        <vs-input class="mr-20 mt-5" placeholder="username เก่าของลูกค้า" v-model="oldUsername"/>
        <vs-button 
          :disabled="!$store.state.AppActiveUser.permissions.user.action || isActionLoading" 
          class="mr-20 mt-5" 
          size="small" 
          icon-pack="feather" 
          :icon="isActionLoading ? 'icon-loader' : 'icon-edit'" 
          color="danger"
          @click="getOldInfoFromUFA()"
        >
          {{ isActionLoading ? 'กำลังดำเนินการ...' : 'ปุ่มดึงข้อมูลยูสเก่าจาก UFA' }}
        </vs-button>
        <p class="mt-4">username ปัจจุบันของลูกค้าจะเปลี่ยนไปเป็น username ที่ท่านกรอกด้านบน</p>
        <p class="mt-4">โปรดยืนยันตัวตนข้อมูลค้าก่อนดึงข้อมูล การดึงข้อมูลลูกค้าในส่วนนี้จะถูกเก็บประวัติทั้งหมด</p>
      </div>
      <vs-divider /> -->

      <!-- Action Buttons -->
      <div class="action-buttons">
        <vs-button 
          :disabled="!$store.state.AppActiveUser.permissions.user.action || isActionLoading" 
          class="mr-20" 
          size="small" 
          icon-pack="feather" 
          :icon="isActionLoading ? 'icon-loader' : 'icon-edit'" 
          color="danger"
          @click="registerUFABET()"
        >
          {{ isActionLoading ? 'กำลังดำเนินการ...' : 'ปุ่มสมัครยูส UFABET' }}
        </vs-button>
        <br>
        <vs-button 
          :disabled="!$store.state.AppActiveUser.permissions.user.action || isActionLoading" 
          class="mr-20" 
          size="small" 
          icon-pack="feather" 
          :icon="isActionLoading ? 'icon-loader' : 'icon-edit'" 
          color="success"
          @click="syncline()"
        >
          {{ isActionLoading ? 'กำลังดำเนินการ...' : 'ยกเลิกเชื่อมต่อไลน์' }}
        </vs-button>
        <br>
        <vs-button 
          :disabled="!$store.state.AppActiveUser.permissions.user.action || isActionLoading" 
          class="mr-20" 
          size="small" 
          icon-pack="feather" 
          :icon="isActionLoading ? 'icon-loader' : 'icon-edit'" 
          color="warning"
          @click="popupkyc()"
        >
          {{ isActionLoading ? 'กำลังดำเนินการ...' : 'ยืนยัน KYC' }}
        </vs-button>
        <br>
        <vs-button 
          :disabled="!$store.state.AppActiveUser.permissions.user.action" 
          class="mr-20" 
          size="small" 
          icon-pack="feather" 
          icon="icon-log-in" 
          color="blue"
          @click="popupLoginWithToken()"
        >
          Login ยูสลูกค้า
        </vs-button>
      </div>
      <vs-divider />

      <!-- KYC Popup -->
      <vs-popup classContent="popup-example" title="ยืนยัน KYC" :active.sync="popup_kyc">
        <br>
        <vx-input-group class="mb-base">
          <template slot="prepend">
            <p> กดยืนยัน KYC </p>
          </template>
        </vx-input-group>
        <vs-button 
          :disabled="!$store.state.AppActiveUser.permissions.user.action || isActionLoading" 
          @click="confrimKyc()" 
          color="primary" 
          type="filled"
        >
          {{ isActionLoading ? 'กำลังดำเนินการ...' : 'ยืนยัน' }}
        </vs-button>
      </vs-popup>

      <!-- Login with Token Popup -->
      <vs-popup 
        classContent="popup-example" 
        title="ยืนยันการ Login ยูสลูกค้า" 
        :active.sync="popup_otp_login_with_auth"
      >
        <br>
        <h3 class="text-center">กรุณากรอก OTP ของท่านเพื่อยืนยัน</h3>
        <br>
        <h4 v-if="memberData.member_username" class="text-center">
          เข้าสู่ระบบด้วยยูส {{ memberData.member_username }}
        </h4>
        <br>
        <div class="text-center">
          <vs-input 
            class="w-full mt-4" 
            label="" 
            v-model="otp" 
            name="otp" 
            placeholder="กรอก OTP"
          />
          <br>
          <vs-button 
            @click="loginWithToken()" 
            color="success" 
            type="filled"
            :disabled="!otp || isActionLoading"
          >
            {{ isActionLoading ? 'กำลังดำเนินการ...' : 'ยืนยัน' }}
          </vs-button>
        </div>
      </vs-popup>

      <!-- UFA Login Information -->
      <vs-list-header title="ข้อมูลสำหรับเข้าเล่น UFA" color="info" icon="people"></vs-list-header>
      <div class="ufa-login-info">
        <p v-if="memberData.member_username">ยูสเซอร์เนม: {{memberData.member_ufa_username}}</p>
        <vs-divider />
        <p>รหัสผ่าน: {{memberData.member_password}}</p>
      </div>

      <!-- Member Information -->
      <vs-list-header title="ข้อมูลสมาชิก" color="success" icon="description"></vs-list-header>
      <div class="member-details">
        <p>ยูสเซอร์เนม : {{memberData.member_username}}</p>
        <vs-divider />
        <p>เบอร์โทร : {{memberData.member_phone}}</p>
        <vs-divider />
        <p>รหัสผ่าน : {{memberData.member_password}}</p>
        <vs-divider />
        <p>ไอพี : {{memberData.member_lastplay_ip}}</p>
        <vs-divider />
        <p>ชื่อ - นามสกุล : {{memberData.member_name}} {{memberData.member_surname}}</p>
        <vs-divider />
        <p>เลขบัญชี : {{memberData.member_bank_number}}</p>
        <vs-divider />
        <p>ธนาคาร : {{memberData.member_bank_type}}</p>
        <vs-divider />
        <p>ไลน์ : {{memberData.member_line}}</p>
        <vs-divider />
        <p>วันที่สมัคร : {{ formatDate(memberData.member_register_date) }}</p>
        <vs-divider />
        <p>วันเกิด: {{ formatBirthDate(memberData.member_birthdate) }}</p>
        <vs-divider />
        <p class="text-success">
          สถานะการเชื่อมต่อ LINE : 
          <span :class="memberData.member_line_user_id !== null ? 'text-success' : 'text-warning'">
            {{ memberData.member_line_user_id !== null ? 'เชื่อมต่อแล้ว' : 'ไม่ได้เชื่อมต่อ' }}
          </span>
        </p>
        <vs-divider />
        <p class="text-primary">ผู้ที่แนะนำมา ขั้นที่ 1 : {{memberData.member_aff}}</p>
        <vs-divider />
        <p class="text-success">ผู้ที่แนะนำมา ขั้นที่ 2 : {{memberData.member_aff2}}</p>
        <vs-divider />
        <p class="text-success">ระดับบัญชีลูกค้า : {{max_deposit}}</p>
        <vs-divider />
        <p class="text-warning">
          บัญชีที่ลูกค้าเห็น (scb/kbank) : {{memberDatabank.bank_for}}
          {{memberDatabank.bank_fullname}} {{memberDatabank.bank_number}} {{memberDatabank.bank_reserve}}
        </p>
        <p class="text-warning">
          บัญชีที่ลูกค้าเห็น (bay) : {{memberDatabankbay.bank_for}}
          {{memberDatabankbay.bank_fullname}} {{memberDatabankbay.bank_number}} {{memberDatabankbay.bank_reserve}}
        </p>
      </div>
      <vs-divider />

      <!-- Statistics -->
      <vs-list-header title="สถิติ" color="blue" icon="swap_horiz"></vs-list-header>
      <div class="statistics">
        <p>ยอดฝาก : {{currency(memberData.member_topup)}} บาท</p>
        <p>ยอดถอน : {{currency(memberData.member_withdraw)}} บาท</p>
      </div>
      <br />
    </vs-list>
  </vx-card>
</template>

<script>
import axios from '../../../axios'
import moment from 'moment'
import { previewPaymentRules } from '@/api/settingPayment'

export default {
  data () {
    return {
      isLoading: true,
      isActionLoading: false,
      memberData: {},
      memberDatabank: {},
      memberDatabankbay: {},
      memberDataSumtransaction: [],
      commentData: [],
      max_deposit: '',
      popup_kyc: false,
      popup_otp_login_with_auth: false,
      otp: '',
      oldUsername: '',
      status: {}, // Added status for notification handling
      /** พรีวิว rule ตามยอดฝากจำลอง — ลำดับ 100, 1000, 10000 บาท */
      paymentRulePreviewRows: [],
      statusBonus: [
        {
          0: 'ไม่รับโบนัส',
          1: '-',
          2: '-',
          3: 'เปิดไพ่ลุ้นโชค',
          4: 'กงล้อลุ้นโชค',
          5: 'โบนัสเครดิตฟรี',
          6: 'โบนัสเครดิตฟรี Ranking',
          7: 'Happy Time',
          8: 'ฝาก 200 รับ 500',
          9: 'ฝาก 500 ได้ 1500',
          10: 'โปรโมชั่นสมาชิกใหม่ 100%',
          11: 'โปรโมชันฝากครั้งแรกของวัน รับ 30%',
          12: 'โปรโมชัน ฝาก 500 รับ 600 บาท'
        }
      ]
    }
  },
  methods: {
    // Utility methods
    currency (amount) {
      if (!amount || amount === 'NaN') {
        amount = 0
      }
      if (amount >= 0) {
        if (typeof amount === 'number') {
          amount = String(Math.abs(amount))
        }
        return (amount).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      } else {
        return `${(amount).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
      }
    },

    formatDate (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },

    formatBirthDate (birthdate) {
      return birthdate ? moment(birthdate).format('YYYY-MM-DD') : '-'
    },

    getBonusTypeClass (bonusType) {
      return bonusType === 0 ? 'text-success' : 'text-danger'
    },

    getBonusTypeText (bonusType) {
      const bonusTypes = {
        0: 'ไม่มี',
        1: 'CASINO',
        2: 'SLOT',
        3: 'SPORT'
      }
      return bonusTypes[bonusType] || 'ไม่มี'
    },

    // Action methods
    async confrimKyc () {
      this.isActionLoading = true
      try {
        await axios
          .post('/member/confrimkyc', {
            username: this.$route.params.username
          }).then(response => (this.status = response.data))
        if (this.status.status === true) {
          this.$vs.notify({
            time: 3000,
            color: 'success',
            position: 'top-right',
            icon: 'check_box',
            title: this.status.info
          })
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        } else {
          this.$vs.notify({
            time: 8000,
            color: 'danger',
            position: 'top-right',
            icon: 'error',
            title: 'ยืนยัน KYC ไม่สำเร็จ',
            text: this.status.info
          })
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        }
      } finally {
        this.isActionLoading = false
      }
    },

    async syncline () {
      this.isActionLoading = true
      try {
        await axios
          .post('/member/syncline', {
            username: this.$route.params.username
          }).then(response => (this.status = response.data))
        if (this.status.status === true) {
          this.$vs.notify({
            time: 3000,
            color: 'success',
            position: 'top-right',
            icon: 'check_box',
            title: this.status.info
          })
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        } else {
          this.$vs.notify({
            time: 8000,
            color: 'danger',
            position: 'top-right',
            icon: 'error',
            text: this.status.info
          })
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        }
      } finally {
        this.isActionLoading = false
      }
    },

    async registerUFABET () {
      this.isActionLoading = true
      try {
        await axios
          .get(`/member/${this.$route.params.username}/registerUFABET`, {
            params: {
              password: this.memberData.member_password
            }
          }).then(response => (this.status = response.data))
        if (this.status.success === true) {
          this.$vs.notify({
            time: 3000,
            color: 'success',
            position: 'top-right',
            icon: 'check_box',
            title: 'ทำรายการสำเร็จ',
            text: this.status.message
          })
        } else {
          this.$vs.notify({
            time: 8000,
            color: 'danger',
            position: 'top-right',
            icon: 'error',
            title: 'ทำรายการไม่สำเร็จ',
            text: this.status.message
          })
        }
      } finally {
        this.isActionLoading = false
      }
    },

    async getOldInfoFromUFA () {
      this.isActionLoading = true
      try {
        const data = {
          'oldUserName': this.oldUsername,
          'newUserName': this.$route.params.username
        }

        const request = await axios
          .post('//member/change/username', data)

        const result = request.data

        if (result.status === true) {
          this.$vs.notify({
            time: 4000,
            color: 'success',
            position: 'top-right',
            icon: 'check_box',
            title: 'ทำรายการสำเร็จ',
            text: result.info
          })
        } else {
          this.$vs.notify({
            time: 4000,
            color: 'danger',
            position: 'top-right',
            icon: 'error',
            title: 'ทำรายการไม่สำเร็จ',
            text: result.info
          })
        }
      } catch (err) {
        this.$vs.notify({
          time: 8000,
          color: 'danger',
          position: 'top-right',
          icon: 'error',
          title: 'ทำรายการไม่สำเร็จ',
          text: err.message
        })
      } finally {
        this.isActionLoading = false
      }
    },

    popupkyc () {
      this.popup_kyc = true
    },

    // Login with Token methods
    popupLoginWithToken () {
      this.otp = ''
      this.popup_otp_login_with_auth = true
    },

    async loginWithToken () {
      if (!this.otp) {
        this.$vs.notify({
          title: 'กรุณากรอก OTP',
          text: 'โปรดกรอก OTP เพื่อยืนยันการเข้าสู่ระบบ',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return
      }

      this.isActionLoading = true
      try {
        const result = await axios
          .post(`/member/${this.memberData.member_username}/loginWithAuthToken`, {
            otp: this.otp
          })
          .catch(error => {
            this.$vs.notify({
              title: 'เกิดข้อผิดพลาด',
              text: (error.response && error.response.data && error.response.data.message) || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
              position: 'top-right',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            return null
          })

        if (!result || !result.data.success) {
          // Login ไม่สำเร็จ - แสดง error notification
          this.$vs.notify({
            title: 'ไม่สามารถเข้าสู่ระบบได้',
            text: (result && result.data && result.data.message) || 'OTP ไม่ถูกต้องหรือหมดอายุ',
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        } else {
          // Login สำเร็จ - แสดง success notification และ redirect
          this.$vs.notify({
            title: 'ยืนยัน OTP สำเร็จ',
            text: result.data.message || 'กำลังเข้าสู่ระบบ...',
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          })
          // Redirect ไปยัง URL ที่ได้จาก response
          if (result.data.url) {
            setTimeout(() => {
              location.href = result.data.url
            }, 1000)
          }
        }
      } finally {
        this.isActionLoading = false
      }
    },

    // Data processing methods
    processBankData (bankData) {
      if (bankData.bank_reserve === false) {
        bankData.bank_reserve = '(บัญขีหลัก)'
      } else if (bankData.bank_reserve === true) {
        bankData.bank_reserve = '(บัญขีสำรอง)'
      }
      return bankData
    },

    calculateMaxDeposit (maxDeposit) {
      if (maxDeposit >= 0 && maxDeposit <= 9999) return 'VIP0'
      if (maxDeposit >= 10000 && maxDeposit <= 19999) return 'VIP1'
      if (maxDeposit >= 20000 && maxDeposit <= 29999) return 'VIP2'
      if (maxDeposit >= 30000 && maxDeposit <= 49999) return 'VIP3'
      return 'VIP4'
    },

    // Initialization methods
    async loadMemberData () {
      try {
        const getMember = await axios
          .get(`/member/${this.$route.params.username}`)

        if (!getMember.data.member_username) {
          this.$vs.notify({
            time: 8000,
            color: 'danger',
            position: 'top-right',
            icon: 'error',
            title: 'ดึงข้อมูลลูกค้าไม่สำเร็จ',
            text: getMember.data.info
          })
        } else {
          this.memberData = getMember.data
        }
      } catch (error) {
        this.$vs.notify({
          time: 8000,
          color: 'danger',
          position: 'top-right',
          icon: 'error',
          title: 'เกิดข้อผิดพลาด',
          text: 'ไม่สามารถโหลดข้อมูลสมาชิกได้'
        })
      }
    },

    async loadAdditionalData () {
      try {
        await axios
          .get(`/member/getComment/${this.$route.params.username}`)
          .then(response => (this.commentData = response.data))

        await axios
          .get(`/member/showbank/${this.$route.params.username}`)
          .then(response => (this.memberDatabank = this.processBankData(response.data)))

        await axios
          .get(`/member/sumtransaction/${this.$route.params.username}`)
          .then(response => {
            this.memberDataSumtransaction = response.data.map(amount => this.currency(amount))
          })
      } catch (error) {
        this.$vs.notify({
          time: 8000,
          color: 'danger',
          position: 'top-right',
          icon: 'error',
          title: 'เกิดข้อผิดพลาด',
          text: 'ไม่สามารถโหลดข้อมูลเพิ่มเติมได้'
        })
      }
    },

    async fetchPaymentRulePreview () {
      const amounts = [100, 1000, 10000]
      this.paymentRulePreviewRows = []
      const username = this.$route.params.username

      for (const amount of amounts) {
        const row = {
          amount,
          ruleName: '',
          paymentCode: '',
          error: ''
        }
        try {
          const res = await previewPaymentRules({
            username,
            deposit_amount: amount
          })
          if (res.status) {
            if (res.matched_rule && res.matched_rule.name) {
              row.ruleName = res.matched_rule.name
            }
            const pc = res.payment_code
            if (pc !== undefined && pc !== null && pc !== '') {
              row.paymentCode = String(pc)
            }
          } else {
            row.error =
              res.message || 'ไม่สามารถโหลดพรีวิว payment rule ได้'
          }
        } catch (e) {
          row.error =
            (e && e.message) || 'เกิดข้อผิดพลาดขณะโหลดพรีวิว payment rule'
        }
        this.paymentRulePreviewRows.push(row)
      }
    }
  },

  async mounted () {
    try {
      await this.loadMemberData()
      await this.loadAdditionalData()
      await this.fetchPaymentRulePreview()

      this.max_deposit = this.calculateMaxDeposit(this.memberData.member_max_deposit)
    } finally {
      this.isLoading = false
    }
  },

  computed: {

  }
}
</script>

<style scoped>
.loading-overlay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  text-align: center;
}

.credit-info,
.kyc-status,
.bonus-info,
.member-level,
.turnover-info,
.old-username-section,
.action-buttons,
.ufa-login-info,
.member-details,
.statistics {
  margin-bottom: 1rem;
}

.action-buttons .vs-button {
  margin-bottom: 0.5rem;
}

/* Disable buttons during loading */
.vs-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
